import { parseTime } from './parseTime';
import { TLD, OpeningHours, DateRange, TimeRange } from '../../types';

export const DAYS_IN_WEEK = 7;
export const HOURS_PER_DAY = 24;
export const MIN_PER_HOUR = 60;
export const SEC_PER_MIN = 60;
export const MS_PER_SEC = 1000;
export const DAYS_TO_MS = HOURS_PER_DAY * MIN_PER_HOUR * SEC_PER_MIN * MS_PER_SEC;

const getFirstDayOfWeekOffset = (region: TLD) => {
  const firstDayOfWeekOffsetMap = {
    [TLD.FR]: 1,
    [TLD.DE]: 1,
    [TLD.NL]: 1,
  };

  return firstDayOfWeekOffsetMap[region] ?? 0;
};

/**
 * get the next/current business day. Assumes sunday to be the first day in `hours`
 */
export const businessDay = (date: Date, hours: OpeningHours): DateRange | null => {
  const startDay = date.getDay();
  let i = startDay;
  let day: number;
  const m = i + DAYS_IN_WEEK;
  let useNext = false;
  let hoursForDay: TimeRange | null = null;
  while (i < m) {
    day = i % DAYS_IN_WEEK;
    hoursForDay = hours[day];
    if (hoursForDay && hoursForDay[0] != null && hoursForDay[1] != null) {
      const daysOffset = i - startDay;
      const timestamp = date.getTime() + daysOffset * DAYS_TO_MS;
      const from = parseTime(hoursForDay[0], new Date(timestamp));
      const to = parseTime(hoursForDay[1], new Date(timestamp));

      if (from && to && (useNext || date < to)) {
        return [from, to];
      } else {
        useNext = true;
      }
    }
    i += 1;
  }

  return null;
};

/*
 * @description: opening hours have a different start day depending on current
 * region. JavaScripts date functions assume sunday o be the first day of the
 * week - so this function also takes care of locale. This function
 * assumes`hours` to start with the appropriate day of week *
 */
export const getBusinessDayForRegion = (date: Date, hours: OpeningHours, region: TLD): DateRange | null => {
  const firstDayOffset = getFirstDayOfWeekOffset(region);
  const offset = DAYS_IN_WEEK - firstDayOffset;
  const offsettedHours = [...hours, ...hours].slice(offset, offset + DAYS_IN_WEEK);
  return businessDay(date, offsettedHours);
};
